export default "__VITE_ASSET___0zRZsis__"